// frontend/src/pages/OrgDetails.jsx
import React, { useEffect, useState } from "react";
import { getOrgDetails } from "../api/orgDetails";

export default function OrgDetails() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function load() {
      setLoading(true);
      setError("");
      try {
        const data = await getOrgDetails();
        if (!ignore) setOrgs(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!ignore) setError(err?.message || "Failed to load organization details");
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    load();
    return () => { ignore = true; };
  }, []);

  function copyToClipboard(text, key) {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(null), 1500);
    });
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 style={{ fontWeight: 500 }}>Organization IDs</h5>
        {!loading && !error && (
          <span className="text-muted small">{orgs.length} organization{orgs.length !== 1 ? "s" : ""}</span>
        )}
      </div>

      {loading && <div className="text-muted">Loading…</div>}

      {error && (
        <div className="alert alert-danger py-2" role="alert">{error}</div>
      )}

      {!loading && !error && (
        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: "80px" }}>FF Org ID</th>
                <th>Name</th>
                <th style={{ width: "110px" }}>Auth Provider</th>
                <th>Provider Org ID</th>
                <th style={{ width: "80px" }}></th>
              </tr>
            </thead>
            <tbody>
              {orgs.map((org) => {
                const copyKey = `${org.ff_org_id}-provider`;
                return (
                  <tr key={org.ff_org_id}>
                    <td className="text-muted">{org.ff_org_id}</td>
                    <td>{org.name}</td>
                    <td>
                      {org.auth_provider ? (
                        <span className={`badge ${org.auth_provider === "auth0" ? "bg-primary" : "bg-warning text-dark"}`}>
                          {org.auth_provider.toUpperCase()}
                        </span>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      {org.error ? (
                        <span className="text-danger small" title={org.error}>⚠ {org.error}</span>
                      ) : org.provider_org_id ? (
                        <code style={{ fontSize: "0.85em" }}>{org.provider_org_id}</code>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      {org.provider_org_id && (
                        <button
                          className="btn btn-outline-secondary btn-sm py-0 px-2"
                          style={{ fontSize: "0.75em" }}
                          onClick={() => copyToClipboard(org.provider_org_id, copyKey)}
                          title="Copy provider org ID"
                        >
                          {copied === copyKey ? "Copied!" : "Copy"}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
              {orgs.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-muted text-center">No organizations found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
